import {FC} from 'react'

import {Trans, useTranslation} from '@/i18n'

import {CardListLayout} from '../common/cards/CardListLayout'
import {TextFontWeight} from '../common/content/Text'
import {TransLink} from '../common/TransLink'
import {ServiceRequestSolutionCard} from './ServiceRequestSolutionCard'

type ServiceRequestSolutionCardContentType = {
  title: string
  description: {
    text: string
    linkHrefs?: string[]
  }
  imageSrc: string
  imageAlt: string
  linkHref?: string
  linkText?: string
}

type ServiceRequestSolutionsProps = {
  title: string
  description?: string
  cards: ServiceRequestSolutionCardContentType[]
  titleMaxWidth?: string
  isImageFullHeight?: boolean
}

export const ServiceRequestSolutions: FC<ServiceRequestSolutionsProps> = ({
  title,
  description,
  cards,
  titleMaxWidth,
  isImageFullHeight,
}) => {
  const {t} = useTranslation()

  return (
    <CardListLayout title={title} titleMaxWidth={titleMaxWidth} description={description}>
      {cards.map(({title, description, imageSrc, imageAlt, linkHref, linkText}) => (
        <ServiceRequestSolutionCard
          key={title}
          title={t(title)}
          description={
            <Trans i18nKey={description.text}>
              text
              {description.linkHrefs?.[0] && (
                <TransLink
                  href={description.linkHrefs?.[0]}
                  fontWeight={TextFontWeight.bold}
                  target="_blank"
                >
                  link
                </TransLink>
              )}
              text
              {description.linkHrefs?.[1] && (
                <TransLink
                  href={description.linkHrefs?.[1]}
                  fontWeight={TextFontWeight.bold}
                  target="_blank"
                >
                  link
                </TransLink>
              )}
            </Trans>
          }
          imageSrc={imageSrc}
          imageAlt={imageAlt}
          linkHref={linkHref}
          linkText={t(linkText)}
          isImageFullHeight={isImageFullHeight}
        />
      ))}
    </CardListLayout>
  )
}
